// demo-webscm 2026 11 02 / ODOO-350612 (слово владельца: «Когда выполняются переходы (в режиме покажи мне), если были клики при переходе с текущего
// положения, нужно показывать цифру в кружочке и короткое примечание 1. Кликаем на такой-то пункт, 2. выбираем то-то»): маршрут показа навигатора —
// какие клики понадобились бы пользователю, чтобы дойти от текущего экрана до цели шага. Выводится АВТОМАТИЧЕСКИ из плана play_plan (шаги goto_page /
// open_widget / open_tab + заголовки стола, страницы, виджета из плана) — автору темы писать ничего не нужно; подсказка цели (последний номер) — его
// text у highlight / wait_for. Номера идут по порядку выполнения, кружок с номером ставит guideTarget_mark({badge}), список — вкладка «Крок» дока.
// Без DOM и без стора — tests/unit/guideRoute.test.mjs; элементы по записям ищет guideRoute_el (ниже, DOM — параметром).
const isObj = (x) => !!(x && typeof x === 'object')
const str = (v) => (v === undefined || v === null) ? '' : String(v)
const identityT = (text, params) => str(text).replace(/\{(\w+)\}/g, (m, k) => (params && k in params) ? str(params[k]) : m)

// записи маршрута до действий тура: [{ kind: 'workspace' | 'page' | 'widget' | 'tab', text, workspace, page, widget, tab }] — без номеров (их даёт исполнение:
// номер получают только записи, чей элемент нашёлся на экране, и подсветки тура после них). cur — { workspace, page } текущего экрана
export function guideRoute_items(plan, steps, cur = {}, t = identityT) {
    const out = []
    if (!isObj(plan) || !Array.isArray(steps)) return out
    let ws = str(cur.workspace), page = str(cur.page)
    for (const st of steps) {
        if (!isObj(st)) continue
        const act = str(st.action)
        if (act === 'goto_page') {
            const toWs = str(st.workspace || plan.workspace), toPage = str(st.page || plan.page)
            if (!toWs) continue
            if (toWs !== ws) {
                const title = toWs === str(plan.workspace) ? (str(plan.workspace_title) || toWs) : (str(st.workspace_title) || toWs)
                out.push({ kind: 'workspace', workspace: toWs, text: t('Open the list of workspaces (button at the top left) and pick «{workspace}»', { workspace: title }) })
                ws = toWs; page = ''
            }
            if (toPage && toPage !== page) {
                const title = toPage === str(plan.page) ? (str(plan.page_title) || toPage) : (str(st.page_title) || toPage)
                out.push({ kind: 'page', workspace: toWs, page: toPage, text: t('On the pages rail click «{page}»', { page: title }) })
                page = toPage
            }
        } else if (act === 'open_widget') {
            if (!st.widget) continue
            const title = str(st.title || (isObj(plan.target) && plan.target.widget === st.widget ? plan.target.title : '') || st.widget)
            out.push({ kind: 'widget', widget: str(st.widget), text: t(st.on_page ? 'Click the widget «{widget}»' : 'Open the widget «{widget}»', { widget: title }) })
        } else if (act === 'open_tab') {
            const tab = str(st.target?.tab)
            if (!tab) continue
            out.push({ kind: 'tab', widget: str(st.target?.widget), tab, text: t('Open the «{tab}» tab', { tab }) })
        }
    }
    return out
}

// элемент записи маршрута на экране (null — нет): стол — кнопка списка столов шапки (data-help topbar.menuToggle), страница — кнопка панели сторінок
// (a[data-page-index]), виджет / вкладка — корень виджета (vueObj.$el; вкладка — пока виджет целиком, как цель kind tab у guideTarget). findWidget — guideTarget_findWidget
export function guideRoute_el(doc, store, item, findWidget) {
    if (!doc || !isObj(item)) return null
    try {
        if (item.kind === 'workspace') return doc.querySelector('[data-help="topbar.menuToggle"]') || null
        if (item.kind === 'page') return doc.querySelector(`a[data-page-index="${str(item.page).replace(/"/g, '\\"')}"]`) || null
        if (item.kind === 'widget' || item.kind === 'tab') {
            const W = typeof findWidget === 'function' ? findWidget(store, { widget: item.widget }) : null
            const el = W?.vueObj?.$el
            return el && el.nodeType === 1 ? el : null
        }
    } catch (e) { return null }
    return null
}

export default { guideRoute_items, guideRoute_el }
